import { useAttendEventMutation } from 'shared/graphql';
import { useToast } from 'shared/hooks';

/**
 * Custom hook to handle attending an event.
 *
 * @returns The attend event function and loading state.
 */
export function useAttendEvent() {
  const { showSuccess, showError } = useToast();

  const [execute, { loading }] = useAttendEventMutation();

  const mutate = async (id: string) => {
    const response = await execute({ variables: { id } });

    const result = response.data?.attendEvent;

    if (result?.success) {
      showSuccess(result.message ?? 'You have successfully registered for this event.');
      return result;
    }

    if (result?.message) {
      showError(result.message);
    }

    return result;
  };

  return {
    mutate,
    loading,
  };
}
